import { createContext } from 'react'

import { ISidebarContextProps } from './types'

export const OrdersContext = createContext({} as ISidebarContextProps)
